// For form submit
export const formSubmit = async (values) => {
  try {
    console.log(values);
  } catch (error) {
    console.log(error);
  }
};
